import React, { useEffect, useState } from "react";
import BarraMenu from "../../components/barraMenu/BarraMenu";
import { ThemeProvider, Typography } from "@mui/material";
import BadgeIcon from '@mui/icons-material/Badge';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';


// Bibliotecas de terceiros
import {
    Box,
    Divider,
    FormControl,
    FormControlLabel,
    FormHelperText,
    InputLabel,
    MenuItem,
    Paper,
    Radio,
    RadioGroup,
    Select,
    TextField,
} from "@mui/material";
import { ToastContainer } from 'react-toastify';
import InputMask from "react-input-mask";
import { useNavigate } from "react-router-dom";

// Componentes próprios
import Loading from "../../components/loading/Loading";

// DTOs
import { Agente } from "../../dto/Agentes";
import { Cidade } from "../../dto/Cidade";
import { FormaCob } from "../../dto/FormaCob";
import { PlanoPagto } from "../../dto/PlanoPagamento";
import { TabPreco } from "../../dto/TabPreco";
import { UF } from "../../dto/Uf";
import { UserInfo } from "../../dto/UserInfo";

// Serviços
import { AgentesService } from "../../services/AgentesService";

//Hooks
import { useLocalidade } from "../hooks/localidade";
import { useAgente } from "../hooks/agente";

// Helpers
import {
    //formatarErros,
    validarCadastroAgente,
    validarDocumento,
} from "../../helpers/ValidaAgente";
import { mostraMensagemErro, mostraMensagemSucesso } from "../../helpers/Notificacoes";
import './Agente.css';
import { ModoBarra } from "../../components/utils";
import SelectPersonalizado from "../../components/inputs/inputSelect";
import { temaEdicao, temaVisualizacao } from '../../components/theme/Theme';
import { VerificaInativo } from "../../helpers/VerificaCampoInativo";
import ModalMensagem from "../../components/modal/Modal";

interface CadAgenteProps {
    modoInicial?: ModoBarra;
    agenteSelecionado?: Agente;
}

const CadAgente: React.FC<CadAgenteProps> = ({ modoInicial, agenteSelecionado }) => {

    const agenteCadastrado: any = null;
    const [modoEdicao, setModoEdicao] = useState<ModoBarra>(modoInicial ?? ModoBarra.leitura);
    const [tema, setTema] = useState(temaVisualizacao)
    const isEditavel = modoEdicao === ModoBarra.edicaoregistro || modoEdicao === ModoBarra.novoregistro;
    const [agenteOriginal, setAgenteOriginal] = useState<Agente | null>(null);

    const agenteService = new AgentesService(() => {
        navigate('/mvp', {
            state: {
                propsPage: 'login'
            }
        });
    });

    const navigate = useNavigate();
    const [userInfo,] = useState<UserInfo>(JSON.parse(localStorage.getItem('udbs')!));

    const {
        verificaAgenteExiste, tabPreco, tabPrecoSelecionada, setTabPrecoSelecionada,
        formaCob, formaCobSelecionada, setFormaCobSelecionada,
        planoPagamento, planoPagamentoSelecionado, setPlanoPagamentoSelecionado,
        dadosCarregados, carregaDadosAgente, localidadesCarregadas,
        buscouTabPreco, buscouFormaCob, buscouPlanoPgto
    } = useAgente();

    const { buscaCidadesUf, setCidades, cidades, uf, haveUf } = useLocalidade();
    const [cidadeSelecionada, setCidadeSelecionada] = useState<Cidade | null>(null);
    const [ufSelecionada, setufSelecionada] = useState<UF>();
    const [dataLancamento,] = useState(() => {
        let data;
        if (agenteSelecionado) {
            data = new Date(agenteSelecionado.dataLancamento);
        } else {
            data = new Date();
        }
        return data.toLocaleDateString("pt-BR");
    });
    const [pessoaJuridica, setPessoaJuridica] = useState<string>(agenteSelecionado?.pessoaJuridica ?? "S");
    const [successCpfCnpj, setSuccessCpfCnpj] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [dadosInvalidos, setDadosInvalidos] = useState<any[]>([]);
    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    const DADOS_VAZIOS: Agente = {
        idEmpresa: userInfo.idEmpresa,
        codAgente: null,
        nome: '',
        nomeFantasia: '',
        pessoaJuridica: '',
        cnpjCpf: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        idCidade: '',
        idUf: '',
        cep: '',
        fone1: '',
        inscricaoEstadual: '',
        email: '',
        idAgenteRepresentante: '',
        tipoCliente: 'S',
        tipoRepresentante: 'N',
        dataLancamento: new Date(),
        idPlanoPagto: '',
        idFormaCob: '',
        ativo: 'S',
        idTabPreco: '',
        idAgente: null,
        representantePrecoManu: 'N',
        representanteEditaAgen: 'S'
    };

    const [agente, setAgente] = useState<Agente>(agenteSelecionado ?? DADOS_VAZIOS);

    useEffect(() => {
        if (agenteSelecionado?.pessoaJuridica) {
            setPessoaJuridica(agenteSelecionado.pessoaJuridica);
        }
    }, [agenteSelecionado]);

    //monitora se o agente foi selecionado, em caso positivo, carrega os dados nas variáveis
    useEffect(() => {
        const buscaDados = async () => {
            if (!buscouTabPreco || !buscouFormaCob || !buscouPlanoPgto) {
                return;
            }

            setIsLoading(true);

            try {
                if (agenteSelecionado && !dadosCarregados && !localidadesCarregadas) {
                    //setPessoaJuridica(agenteSelecionado.pessoaJuridica);
                    const dados = await carregaDadosAgente(agente);

                    if (dados) {
                        setTabPrecoSelecionada(dados.dadosAgente?.tabPreco);
                        setPlanoPagamentoSelecionado(dados.dadosAgente?.planoPagto);
                        setFormaCobSelecionada(dados.dadosAgente?.formaCob);
                        setufSelecionada(dados.localidadeAgente?.uf);
                        setCidadeSelecionada(dados.localidadeAgente?.cidadeSelecionada);
                    }
                }
            } finally {
                setIsLoading(false);
            }
        };
        buscaDados();
    }, [agenteSelecionado, dadosCarregados, carregaDadosAgente, localidadesCarregadas, buscouTabPreco, buscouFormaCob, buscouPlanoPgto]);


    //Verifica a uf selecionada e carrega as cidades de acordo
    useEffect(() => {
        const buscaCidades = async () => {
            if (!ufSelecionada) {
                return;
            }
            const cidades = await buscaCidadesUf(ufSelecionada.idUf);
            setCidades(cidades?.length > 0 ? cidades : []);
        }
        buscaCidades();
    }, [ufSelecionada])

    useEffect(() => {
    }, [tema]);

    function updatePage(page: string, espera?: boolean) {

        if (espera) {
            setTimeout(() => {
                navigate("/mvp", {
                    state: {
                        propsPage: page
                    }
                });
            }, 3000);
        } else {
            navigate("/mvp", {
                state: {
                    propsPage: page
                }
            });
        }
    };

    //Faz a validação do cnpj e/ou cpf do agente
    async function validaDocAgente(doc: string) {
        const valido = await validarDocumento(doc, pessoaJuridica!);
        if (valido !== null) {
            setErrors(prevErrors => ({ ...prevErrors, cnpjCpf: "O campo 'cnpjCpf' é inválido." }));
            setSuccessCpfCnpj(false);
            return;
        }

        setErrors(prevErrors => ({ ...prevErrors, cnpjCpf: "" }));
        setSuccessCpfCnpj(true);
    }


    function handleSelectFormaCob(id: string) {
        const formaCobFilter = formaCob.find((formaCob: any) => formaCob.idFormaCob === id)
        setFormaCobSelecionada(formaCobFilter as FormaCob);
    };


    function handleSelectTabPreco(id: string) {
        const tabPrecoFilter = tabPreco.find((tabPreco: any) => tabPreco.idTabPreco === id)
        setTabPrecoSelecionada(tabPrecoFilter as TabPreco);
    };


    function handleSelectPlanoPagamento(id: string) {
        const planoPagamentoFilter = planoPagamento.find((planoPagamento: any) => planoPagamento.idPlanoPagto === id)
        setPlanoPagamentoSelecionado(planoPagamentoFilter as PlanoPagto);
    };


    function handleSelectCidade(id: string) {
        const cidadeFilter = cidades.find((cidade: any) => cidade.idCidade === id)
        setCidadeSelecionada(cidadeFilter!);
    };


    function handleSelectUf(id: string) {
        const ufFilter = uf.find((data: UF) => data.idUf === id);
        setufSelecionada(ufFilter);
        setCidadeSelecionada(null);
        buscaCidadesUf(id); // ← usa diretamente o id
    }

    function confereCamposAtivos() {
        const dadosInvalidos = [];

        const dadosFinanceiro = VerificaInativo(
            [
                { nome: 'Plano de Pagamento', objeto: planoPagamentoSelecionado },
                { nome: 'Forma de Cobrança', objeto: formaCobSelecionada },
                { nome: 'Tabela de Preço', objeto: tabPrecoSelecionada }
            ]
        );
        if (dadosFinanceiro.length) {
            dadosInvalidos.push({ titulo: 'Financeiro', mensagem: dadosFinanceiro })
        }

        if (dadosInvalidos.length) {
            setDadosInvalidos(dadosInvalidos);
            setOpenModal(true);
            setIsLoading(false);
            return false;
        }

        return true;
    }

    async function salvarAgente() {
        agente.idEmpresa = userInfo.idEmpresa;
        agente.idAgenteRepresentante = userInfo.idAgente;
        agente.pessoaJuridica = pessoaJuridica;
        setIsLoading(true);

        const erros = await validarCadastroAgente(agente!);

        if (agente.cnpjCpf) {
            const erroDoc = await validarDocumento(agente.cnpjCpf, pessoaJuridica!);
            if (erroDoc) erros["cnpjCpf"] = erroDoc;
        }

        // const errosFormatados = formatarErros(errosArray);
        setErrors(erros);

        if (Object.keys(erros).length > 0) {
            mostraMensagemErro("Preencha todos os campos obrigatórios corretamente.");
            setIsLoading(false);
            return;
        }

        if (!confereCamposAtivos()) {
            setIsLoading(false);
            return;
        }


        const cadastroAgente: Agente = {
            idAgente: agente.idAgente,
            idEmpresa: userInfo.idEmpresa,
            codAgente: agente.codAgente || null,
            nome: agente!.nome,
            nomeFantasia: agente?.nomeFantasia || null,
            pessoaJuridica: pessoaJuridica,
            cnpjCpf: agente?.cnpjCpf,
            logradouro: agente!.logradouro,
            numero: agente?.numero,
            complemento: agente?.complemento || null,
            bairro: agente!.bairro,
            idCidade: cidadeSelecionada!.idCidade,
            idUf: ufSelecionada!.idUf,
            cep: agente?.cep || null,
            fone1: agente?.fone1 || null,
            inscricaoEstadual: agente?.inscricaoEstadual || null,
            email: agente?.email || null,
            idAgenteRepresentante: userInfo.idAgente,
            tipoCliente: agente.tipoCliente,
            tipoRepresentante: agente?.tipoRepresentante,
            dataLancamento: agente?.dataLancamento || new Date(),
            idPlanoPagto: planoPagamentoSelecionado?.idPlanoPagto || null,
            idFormaCob: formaCobSelecionada?.idFormaCob || null,
            ativo: agente.ativo,
            idTabPreco: tabPrecoSelecionada?.idTabPreco || null,
            representantePrecoManu: agente.representantePrecoManu,
            representanteEditaAgen: agente.representanteEditaAgen || 'S'
        };

        if (modoInicial === ModoBarra.novoregistro) {
            if (await verificaAgenteExiste(cadastroAgente.cnpjCpf!)) {
                mostraMensagemErro("Já existe um agente cadastrado com este cnpj/cpf");
                setIsLoading(false);
                return;
            };
        }

        const agenteCadastrado = await agenteService.put("/v1/agente", undefined, [cadastroAgente]);

        if (agenteCadastrado.codigo === 200) {
            mostraMensagemSucesso("Agente cadastrado com sucesso");

            // Atualiza estado com agente salvo
            setAgente(cadastroAgente);
            setAgenteOriginal(cadastroAgente);

            if (modoInicial === ModoBarra.edicao) {
                setModoEdicao(ModoBarra.edicao); // mostra botão "Editar"
            } else {
                setModoEdicao(ModoBarra.insercao); // mostra botão "Novo"
            }
            updatePage('agente', true);

        } else {
            mostraMensagemErro(agenteCadastrado.mensagem);
        }
        setIsLoading(false);

    };

    /*  function CancelarNovo(){
         return
     } */


    function voltar() {
        if (successCpfCnpj) {
            const confirma = window.confirm('Os dados preenchidos serão perdidos');

            if (confirma) {
                updatePage("agente");
            }
            else return;
        }
        updatePage("agente");
    };

    function EditarAgente() {
        setAgenteOriginal(agente); // guarda o estado original
        setModoEdicao(ModoBarra.edicaoregistro);
        setTema(temaEdicao)
    }

    function NovoAgente() {
        setAgenteOriginal(null); // limpa estado original
        setAgente({
            ...DADOS_VAZIOS,
            idAgente: null,
            codAgente: null,
        });
        setTabPrecoSelecionada(null);
        setFormaCobSelecionada(null);
        setPlanoPagamentoSelecionado(null);
        setPessoaJuridica("S");
        setModoEdicao(ModoBarra.novoregistro);
        setTema(temaEdicao)
    }

    function Cancelar() {
        if ((modoEdicao === ModoBarra.edicaoregistro || modoEdicao === ModoBarra.novoregistro) && agenteOriginal) {
            setAgente(agenteOriginal);
            setTabPrecoSelecionada(tabPreco.find(x => x.idTabPreco === agenteOriginal.idTabPreco) || null);
            setPlanoPagamentoSelecionado(planoPagamento.find(x => x.idPlanoPagto === agenteOriginal.idPlanoPagto) || null);
            setFormaCobSelecionada(formaCob.find(x => x.idFormaCob === agenteOriginal.idFormaCob) || null);

            setPessoaJuridica(agenteOriginal.pessoaJuridica);
            setModoEdicao(ModoBarra.edicao);
            setTema(temaVisualizacao);
        } else {
            setAgente(DADOS_VAZIOS);
            setTabPrecoSelecionada(null);
            setPlanoPagamentoSelecionado(null);
            setFormaCobSelecionada(null);

            setPessoaJuridica("S");
            setModoEdicao(ModoBarra.leitura);
            setTema(temaVisualizacao);
        }
    }


    return (
        <div className='paginaCadastro'>
            <ThemeProvider theme={tema}>
                <Box className='containerFormCadastro'>

                    <Paper elevation={0} className='agente-paper-header'>
                        <Box className='agente-cad-header-row'>
                            <Box className='agente-cad-title-wrap'>
                                <Box className='agente-cad-title-icon'>
                                    <BadgeIcon />
                                </Box>
                                <Box>
                                    <Typography className='agente-cad-title'>
                                        Cadastro de Agente
                                    </Typography>
                                    <Typography className='agente-cad-subtitle'>
                                        Gerencie as informações e dados do agente cadastrado.
                                    </Typography>
                                </Box>
                            </Box>
                            <Box className='agente-cad-actions'>
                                <BarraMenu
                                    modoAtual={modoEdicao}
                                    onAcao={(acao) => {
                                        if (acao === "edicaoregistro") EditarAgente();
                                        if (acao === "cancelar" || acao === "voltar") Cancelar();
                                        if (acao === "novoregistro") NovoAgente();
                                        if (acao === "sair") voltar();
                                        if (acao === "salvar") salvarAgente();
                                    }}
                                />
                            </Box>
                        </Box>
                    </Paper>

                    <Box className='agente-form-card'>
                        {isLoading && <Loading />}

                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
                            {/*Dados Cadastrais*/}
                            <Box >
                                <Typography variant="subtitle1" className='agente-section-title'>
                                    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
                                        <AssignmentIndOutlinedIcon sx={{ fontSize: 16 }} />
                                        Dados Cadastrais
                                    </Box>
                                </Typography>
                                <Divider className='agente-divider' />
                            </Box>

                            <Box sx={{ display: "flex", justifyContent: 'space-between', marginLeft: 3 }}>

                                {/* Pessoa Física ou Jurídica */}
                                <RadioGroup
                                    row
                                    value={pessoaJuridica}
                                    onChange={(e) => {
                                        setPessoaJuridica(e.target.value);
                                        setAgente((prevAgente) => ({
                                            ...prevAgente,
                                            pessoaJuridica: e.target.value,
                                            cnpjCpf: ''
                                        }));
                                    }}
                                >
                                    <FormControlLabel sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px', color: '#64748B' } }}
                                        value="N"
                                        control={<Radio disabled={!isEditavel} sx={{
                                            '& .MuiSvgIcon-root': { fontSize: 18 } // padrão é 24
                                        }} />}
                                        label="Física"
                                    />
                                    <FormControlLabel sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px', color: '#64748B' } }}
                                        value="S"
                                        control={<Radio disabled={!isEditavel} sx={{
                                            '& .MuiSvgIcon-root': { fontSize: 18 } // padrão é 24
                                        }} />}
                                        label="Jurídica"
                                    />

                                </RadioGroup>


                                {/* Código do Agente */}
                                <TextField label="Código"
                                    sx={{ width: 150 }}
                                    size="small"
                                    value={agente.codAgente}
                                    InputLabelProps={{ shrink: true }}
                                    disabled={true} />

                                {/* Data de Lançamento */}
                                <InputMask
                                    mask="99/99/9999"
                                    value={dataLancamento}
                                    disabled={true}
                                >
                                    {(inputProps: any) => (
                                        <TextField
                                            size="small"
                                            {...inputProps}
                                            label="Data lançamento"
                                            variant="outlined"
                                            sx={{
                                                width: 150,
                                                "& .MuiOutlinedInput-root": {
                                                    "&.Mui-disabled fieldset": {
                                                        borderColor: "#ccc",
                                                    },
                                                    "&:hover fieldset": {
                                                        borderColor: !isEditavel ? "#ccc" : undefined,
                                                    },
                                                    "&.Mui-focused fieldset": {
                                                        borderColor: !isEditavel ? "#ccc" : undefined,
                                                    },
                                                },
                                            }}

                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{ ...inputProps.inputProps, disabled: true }}
                                        />
                                    )}
                                </InputMask>

                                {/* ATIVO */}
                                <FormControl
                                    sx={{
                                        width: 150,
                                        '& .MuiOutlinedInput-root': {
                                            backgroundColor: '#fff'
                                        },
                                        '& .MuiInputLabel-root': {
                                            backgroundColor: '#fff',
                                            padding: '0 5px'
                                        }
                                    }}>

                                    <InputLabel>Status</InputLabel>
                                    <Select
                                        value={agente.ativo}
                                        disabled={true}
                                        size="small"

                                    >
                                        <MenuItem key="ativo" value="S">
                                            Ativo
                                        </MenuItem>
                                        <MenuItem key="inativo" value="N">
                                            Inativo
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>

                            {/*<Divider sx={{ maxWidth: 1000 }} />*/}
                            <Box sx={{ display: "flex", gap: 2 }}>

                                {/* <InputMask
                                    key={pessoaJuridica} // força recriação quando muda
                                    mask={pessoaJuridica === "N" ? "999.999.999-99" : "99.999.999/9999-99"}
                                    placeholder={pessoaJuridica === "N" ? "___.___.___-__" : "__.___.___/____-__"}
                                    value={agente.cnpjCpf || ''}
                                    disabled={!isEditavel}

                                    onChange={(e) => {
                                        const newValue = e.target.value.trim();
                                        setAgente((prevAgente) => ({
                                            ...prevAgente,
                                            cnpjCpf: newValue,
                                        }));
                                    }}
                                    onBlur={(e) => {
                                        validaDocAgente(e.target.value);
                                    }}>
                                    {(inputProps) => (
                                        <TextField
                                            {...inputProps}
                                            size="small"
                                            className="fields"
                                            id="cnpj"
                                            label="CNPJ/CPF"
                                            variant="outlined"
                                            sx={{
                                                width: 300,
                                                "& .MuiOutlinedInput-root": {
                                                    "&.Mui-disabled fieldset": {
                                                        borderColor: "#ccc",
                                                    },
                                                    "&:hover fieldset": {
                                                        borderColor: !isEditavel ? "#ccc" : undefined,
                                                    },
                                                    "&.Mui-focused fieldset": {
                                                        borderColor: !isEditavel ? "#ccc" : undefined,
                                                    },
                                                },
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{ ...inputProps.inputProps, disabled: !isEditavel }}
                                            error={!!errors.cnpjCpf}
                                            helperText={errors.cnpjCpf}
                                            required
                                        />
                                    )}
                                </InputMask> */}

                                <InputMask
                                    key={pessoaJuridica}
                                    mask={pessoaJuridica === "N" ? "999.999.999-99" : "**.***.***/****-99"}
                                    placeholder={pessoaJuridica === "N" ? "___.___.___-__" : "__.___.___/____-__"}
                                    value={agente.cnpjCpf || ""}
                                    disabled={!isEditavel}
                                    onChange={(e) => {
                                        const newValue = e.target.value.trim();
                                        setAgente((prevAgente) => ({
                                            ...prevAgente,
                                            cnpjCpf: newValue,
                                        }));
                                    }}
                                    onBlur={(e) => {
                                        validaDocAgente(e.target.value);
                                    }}
                                >
                                    {(inputProps: any) => {
                                        const { color, ...safeProps } = inputProps;

                                        return (
                                            <TextField
                                                {...safeProps}
                                                size="small"
                                                className="fields"
                                                id="cnpj"
                                                label="CNPJ/CPF"
                                                variant="outlined"
                                                sx={{
                                                    width: 300,
                                                    "& .MuiOutlinedInput-root": {
                                                        "&.Mui-disabled fieldset": {
                                                            borderColor: "#ccc",
                                                        },
                                                        "&:hover fieldset": {
                                                            borderColor: !isEditavel ? "#ccc" : undefined,
                                                        },
                                                        "&.Mui-focused fieldset": {
                                                            borderColor: !isEditavel ? "#ccc" : undefined,
                                                        },
                                                    },
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{
                                                    ...safeProps,
                                                    disabled: !isEditavel,
                                                }}
                                                error={!!errors.cnpjCpf}
                                                helperText={errors.cnpjCpf}
                                                required
                                            />
                                        );
                                    }}
                                </InputMask>

                                <TextField
                                    label="Razão Social"
                                    size="small"
                                    value={agente.nome || ''}
                                    sx={{ width: 700 }}
                                    onChange={(e) => setAgente((prevAgente) => ({
                                        ...prevAgente,
                                        nome: e.target.value
                                    }))}
                                    error={!!errors.nome}
                                    helperText={errors.nome}
                                    required
                                    disabled={!isEditavel}
                                    inputProps={{ maxLength: 60 }}
                                    InputLabelProps={{
                                        sx: { fontSize: '14px' },
                                        //shrink: true
                                    }}
                                />
                            </Box>

                            <Box sx={{ display: "flex", gap: 2 }}>
                                <TextField
                                    label="Nome Fantasia"
                                    size="small"
                                    value={agente.nomeFantasia || ''}
                                    sx={{ width: 700 }}
                                    onChange={(e) => setAgente((prevAgente) => ({
                                        ...prevAgente,
                                        nomeFantasia: e.target.value
                                    }))}
                                    disabled={!isEditavel}
                                    inputProps={{ maxLength: 50 }}
                                    InputLabelProps={{
                                        sx: { fontSize: '14px' }
                                    }}
                                />

                                <TextField
                                    label="Inscrição Estadual"
                                    size="small"
                                    value={agente.inscricaoEstadual || ''}
                                    sx={{ width: 300 }}
                                    onChange={(e) => setAgente((prevAgente) => ({
                                        ...prevAgente,
                                        inscricaoEstadual: e.target.value
                                    }))}
                                    disabled={!isEditavel}
                                    InputLabelProps={{
                                        sx: { fontSize: '14px' }
                                    }}
                                />
                            </Box>

                            <Box sx={{ mt: 1 }}>
                                <Typography variant="subtitle1" className='agente-section-title'>
                                    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
                                        <LocationOnOutlinedIcon sx={{ fontSize: 16 }} />
                                        Endereço
                                    </Box>
                                </Typography>
                                <Divider className='agente-divider' />
                            </Box>

                            <Box sx={{ display: "flex", gap: 2 }}>
                                <InputMask
                                    mask="99999-999"
                                    placeholder="_____-___"
                                    value={agente.cep! || ''}
                                    onChange={(e) =>
                                        setAgente((prevAgente: any) => ({
                                            ...prevAgente,
                                            cep: e.target.value,
                                        }))
                                    }
                                    disabled={!isEditavel}
                                >
                                    {() => (
                                        <TextField
                                            className="fields"
                                            id="cep"
                                            label="CEP"
                                            size="small"
                                            placeholder="_____-___"
                                            variant="outlined"
                                            sx={{ width: 150 }}
                                            InputLabelProps={{ shrink: true }}
                                            disabled={!isEditavel}
                                            error={!!errors.cep}
                                            helperText={errors.cep}
                                        />
                                    )}
                                </InputMask>

                                <TextField
                                    label="Logradouro"
                                    size="small"
                                    sx={{ width: 500 }}
                                    value={agente?.logradouro || ''}
                                    InputLabelProps={{ shrink: true }}
                                    error={!!errors.logradouro}
                                    helperText={errors.logradouro}
                                    required
                                    onChange={(e) => setAgente((prevAgente) => ({
                                        ...prevAgente,
                                        logradouro: e.target.value
                                    }))}
                                    disabled={!isEditavel}
                                />
                                <TextField
                                    label="Nº"
                                    size="small"
                                    sx={{ width: 150 }}
                                    value={agente?.numero || ''}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e) => setAgente((prevAgente) => ({
                                        ...prevAgente,
                                        numero: e.target.value
                                    }))}
                                    disabled={!isEditavel}
                                    error={!!errors.numero}
                                    helperText={errors.numero}
                                    required
                                />
                                <TextField
                                    label="Compl."
                                    size="small"
                                    sx={{ width: 200 }}
                                    value={agente?.complemento || ''}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e) => setAgente((prevAgente) => ({
                                        ...prevAgente,
                                        complemento: e.target.value
                                    }))}
                                    disabled={!isEditavel}
                                />
                            </Box>

                            <Box sx={{ display: "flex", gap: 2 }}>
                                <TextField
                                    label="Bairro"
                                    size="small"
                                    sx={{ flex: 2 }}
                                    value={agente?.bairro || ''}
                                    InputLabelProps={{ shrink: true }}
                                    error={!!errors.bairro}
                                    helperText={errors.bairro}
                                    required
                                    onChange={(e) => setAgente((prevAgente) => ({
                                        ...prevAgente,
                                        bairro: e.target.value
                                    }))}
                                    disabled={!isEditavel}
                                />

                                <FormControl fullWidth error={!!errors.idUf}
                                    sx={{
                                        width: 100,
                                        '& .MuiOutlinedInput-root': {
                                            backgroundColor: '#fff'
                                        },
                                        '& .MuiInputLabel-root': {
                                            backgroundColor: '#fff',
                                            padding: '0 5px'
                                        }
                                    }}>
                                    <InputLabel required shrink >UF</InputLabel>

                                    <SelectPersonalizado
                                        value={ufSelecionada?.idUf ?? ""}
                                        label={"UF"}
                                        onChange={(valor) => handleSelectUf(valor)}
                                        options={uf.map((item) => ({
                                            value: item.idUf,
                                            label: item.uf,
                                        }))}
                                        required
                                        disabled={!isEditavel}
                                        sx={{ "width": 100, "heigth": 0 }}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 400, // altura máxima da janela do menu
                                                    overflowY: 'auto'
                                                }
                                            }
                                        }} />

                                    {errors.idUf && <FormHelperText>{errors.idUf}</FormHelperText>}
                                </FormControl>

                                <FormControl fullWidth error={!!errors.idCidade}
                                    sx={{
                                        flex: 1,
                                        minWidth: 300,
                                        '& .MuiOutlinedInput-root': {
                                            backgroundColor: '#fff'
                                        },
                                        '& .MuiInputLabel-root': {
                                            backgroundColor: '#fff',
                                            padding: '0 5px'
                                        }
                                    }}>
                                    <InputLabel required shrink>Cidade</InputLabel>

                                    <SelectPersonalizado
                                        value={cidadeSelecionada?.idCidade ?? ""}
                                        label={"Cidade"}
                                        onChange={(valor) => {
                                            handleSelectCidade(valor)
                                            setAgente((prevAgente) => ({
                                                ...prevAgente,
                                                idCidade: valor
                                            }));
                                        }
                                        }
                                        options={cidades.map((item) => ({
                                            value: item.idCidade,
                                            label: item.nome,
                                        }))}
                                        required
                                        disabled={!isEditavel || !ufSelecionada}
                                        sx={{ width: 300 }}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 200, // altura máxima da janela do menu
                                                    overflowY: 'auto'
                                                }
                                            }
                                        }} />

                                    {errors.idCidade && <FormHelperText>{errors.idCidade}</FormHelperText>}
                                </FormControl>

                            </Box>

                            <Box sx={{ mt: 1 }}>
                                <Typography variant="subtitle1" className='agente-section-title'>
                                    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
                                        <StorefrontOutlinedIcon sx={{ fontSize: 16 }} />
                                        Informações Comerciais
                                    </Box>
                                </Typography>
                                <Divider className='agente-divider' />
                            </Box>

                            <Box sx={{ display: "flex", gap: 2 }}>

                                <TextField
                                    className="fields"
                                    id="telefone"
                                    label="Telefone"
                                    size="small"
                                    variant="outlined"
                                    sx={{ width: 250 }}
                                    InputLabelProps={{ shrink: true }}
                                    value={agente.fone1 || ''}
                                    onChange={(e) => setAgente((prevAgente) => ({
                                        ...prevAgente,
                                        fone1: e.target.value,
                                    }))}
                                    error={!!errors.fone1}
                                    helperText={errors.fone1}
                                    disabled={!isEditavel}
                                />
                                <TextField
                                    label="E-mail"
                                    size="small"
                                    sx={{ width: 750 }}
                                    InputLabelProps={{ shrink: true }}
                                    error={!!errors.email}
                                    helperText={errors.email}
                                    onChange={(e) => setAgente((prevAgente) => ({
                                        ...prevAgente,
                                        email: e.target.value
                                    }))}
                                    value={agente.email || ''}
                                    disabled={!isEditavel}
                                />
                            </Box>

                            <Box sx={{ display: "flex", gap: 2 }}>
                                <FormControl fullWidth error={!!errors.idTabPreco} sx={{
                                    minWidth: 200,
                                    '& .MuiOutlinedInput-root': {
                                        backgroundColor: '#fff'
                                    },
                                    '& .MuiInputLabel-root': {
                                        backgroundColor: '#fff',
                                        padding: '0 5px'
                                    }
                                }}>
                                    <InputLabel shrink>Tabela de Preço</InputLabel>

                                    <SelectPersonalizado
                                        value={tabPrecoSelecionada?.idTabPreco ?? ''}
                                        label={"Tabela de Preço"}
                                        onChange={(valor) => handleSelectTabPreco((valor))}
                                        options={tabPreco.map((item) => ({
                                            value: item.idTabPreco,
                                            label: item.descricao,
                                            ativo: item.ativo
                                        }))}

                                        disabled={!isEditavel}
                                        sx={{}}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 300, // altura máxima da janela do menu
                                                    overflowY: 'auto'
                                                }
                                            }
                                        }} />

                                    {errors.idTabPreco && <FormHelperText>{errors.idTabPreco}</FormHelperText>}
                                </FormControl>

                                <FormControl fullWidth error={!!errors.idPlanoPagto} sx={{
                                    minWidth: 200,
                                    '& .MuiOutlinedInput-root': {
                                        backgroundColor: '#fff'
                                    },
                                    '& .MuiInputLabel-root': {
                                        backgroundColor: '#fff',
                                        padding: '0 5px'
                                    }
                                }}>
                                    <InputLabel shrink>Plano de Pagamento</InputLabel>

                                    <SelectPersonalizado
                                        value={planoPagamentoSelecionado?.idPlanoPagto ?? ''}
                                        label={"Plano de Pagamento"}
                                        onChange={(valor) => handleSelectPlanoPagamento((valor))}
                                        options={planoPagamento.map((item) => ({
                                            value: item.idPlanoPagto,
                                            label: item.descricao,
                                            ativo: item.ativo
                                        }))}
                                        disabled={!isEditavel}
                                        sx={{}}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 300, // altura máxima da janela do menu
                                                    overflowY: 'auto'
                                                }
                                            }
                                        }} />

                                    {errors.idPlanoPagto && <FormHelperText>{errors.idPlanoPagto}</FormHelperText>}
                                </FormControl>

                                <FormControl fullWidth error={!!errors.idFormaCob} sx={{
                                    minWidth: 200,
                                    '& .MuiOutlinedInput-root': {
                                        backgroundColor: '#fff'
                                    },
                                    '& .MuiInputLabel-root': {
                                        backgroundColor: '#fff',
                                        padding: '0 5px'
                                    }
                                }}>
                                    <InputLabel shrink>Forma de Cobrança</InputLabel>

                                    <SelectPersonalizado
                                        value={formaCobSelecionada?.idFormaCob ?? ''}
                                        label={"Forma de Cobrança"}
                                        onChange={(valor) => handleSelectFormaCob((valor))}
                                        options={formaCob.map((item) => ({
                                            value: item.idFormaCob,
                                            label: item.descricao,
                                            ativo: item.ativo
                                        }))}
                                        disabled={!isEditavel}
                                        sx={{}}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 300, // altura máxima da janela do menu
                                                    overflowY: 'auto'
                                                }
                                            }
                                        }} />

                                    {errors.idFormaCob && <FormHelperText>{errors.idFormaCob}</FormHelperText>}
                                </FormControl>
                            </Box>

                        </Box>
                        <ModalMensagem
                            mensagem="Validação do agente"
                            open={openModal}
                            onClose={() => setOpenModal(false)}
                            dados={dadosInvalidos}
                        />
                        <ToastContainer />
                    </Box>

                </Box>
            </ThemeProvider>
        </div>);
}

export default CadAgente;